import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll'

import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  modal: 'data-popup',
  wrapper: 'data-popup-wrapper',
  content: 'data-popup-content',
  close: 'data-popup-close',
}
const qsAll = {}

export const toggleModal = (toggle = true, content = null, node = null, clear = true, customClasses = {}) => {
  if (toggle) {
    disablePageScroll()
    
    if (dom.wrapper._customClasses) {
      dom.wrapper._customClasses.forEach(cls => dom.wrapper.classList.remove(cls))
      dom.wrapper._customClasses = null
    }
    if (dom.modal._customClasses) {
      dom.modal._customClasses.forEach(cls => dom.modal.classList.remove(cls))
      dom.modal._customClasses = null
    }
    if (dom.close._customClasses) {
      dom.close._customClasses.forEach(cls => dom.close.classList.remove(cls))
      dom.close._customClasses = null
    }
    
    if (customClasses.wrapper) {
      const classes = customClasses.wrapper.split(' ').filter(c => c)
      classes.forEach(cls => dom.wrapper.classList.add(cls))
      dom.wrapper._customClasses = classes
    }
    
    if (customClasses.modal) {
      const classes = customClasses.modal.split(' ').filter(c => c)
      classes.forEach(cls => dom.modal.classList.add(cls))
      dom.modal._customClasses = classes
    }
    
    if (customClasses.close) {
      const classes = customClasses.close.split(' ').filter(c => c)
      classes.forEach(cls => dom.close.classList.add(cls))
      dom.close._customClasses = classes
    }
  } else {
    enablePageScroll()
    
    if (dom.wrapper._customClasses) {
      dom.wrapper._customClasses.forEach(cls => dom.wrapper.classList.remove(cls))
      dom.wrapper._customClasses = null
    }
    if (dom.modal._customClasses) {
      dom.modal._customClasses.forEach(cls => dom.modal.classList.remove(cls))
      dom.modal._customClasses = null
    }
    if (dom.close._customClasses) {
      dom.close._customClasses.forEach(cls => dom.close.classList.remove(cls))
      dom.close._customClasses = null
    }
  }
  
  if (clear) dom.content.innerHTML = ''
  if (content) dom.content.innerHTML = content
  if (!content && node) dom.content.appendChild(node)
  
  dom.modal.classList.toggle('z-[-1]', !toggle)
  dom.modal.classList.toggle('opacity-0', !toggle)
  dom.modal.classList.toggle('z-full', toggle)
  dom.modal.classList.toggle('opacity-100', toggle)
  document.body.classList.toggle('overflow-hidden', toggle)
}

export const setupPopup = () => {
  cacheDom(dom, qs, qsAll)

  window.openPopup = (modalContent, modalNode = null) => {
    toggleModal(true, modalContent, modalNode)
  }

  dom.close.addEventListener('click', () => {
    toggleModal(false)
  })
  dom.wrapper.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.modal.addEventListener('click', () => {
    toggleModal(false)
  })
}
